var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasCompleteTheLook
    ? _c(
        "div",
        { staticClass: "product_look_builder" },
        [
          !_vm.isLoading
            ? [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container",
                    class: { "px-0": _vm.windowWidth <= 992 }
                  },
                  [
                    _vm.windowWidth <= 768
                      ? _c("div", { staticClass: "row mx-0" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "slick",
                                {
                                  ref: "lookMobileSlider",
                                  staticClass: "product__carousel",
                                  attrs: { options: _vm.slickOptions }
                                },
                                _vm._l(_vm.completeLookProducts, function(
                                  product
                                ) {
                                  return _c("listing-product-item", {
                                    key: product.id,
                                    attrs: {
                                      product: product,
                                      hideVariantSelector: false,
                                      lookEnabled: true,
                                      translations: _vm.translations
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "slick",
                                {
                                  staticClass: "product__carousel",
                                  attrs: { options: _vm.slickOptions }
                                },
                                _vm._l(_vm.completeLookProducts, function(
                                  product
                                ) {
                                  return _c("listing-product-item", {
                                    key: product.id,
                                    class: "px-1",
                                    attrs: {
                                      product: product,
                                      translations: _vm.translations,
                                      hideVariantSelector: false,
                                      lookEnabled: true
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ])
                  ]
                )
              ]
            : _c("div", { staticClass: "container" }, [
                _vm.isLoading
                  ? _c("div", { staticClass: "text-center" }, [
                      _c(
                        "p",
                        {
                          staticClass: "lead",
                          attrs: { "data-products": _vm.completeLookProducts }
                        },
                        [_vm._v("Loading complete the look")]
                      ),
                      _vm._v(" "),
                      _vm._m(1)
                    ])
                  : _vm._e()
              ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", { staticClass: "pb-6" }, [_vm._v("Complete The Look")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-animation" }, [
      _c("div", { staticClass: "bounce1" }),
      _vm._v(" "),
      _c("div", { staticClass: "bounce2" }),
      _vm._v(" "),
      _c("div", { staticClass: "bounce3" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }